
import React from 'react'

import UserAvatar from '@/Components/UserAvatar/UserAvatar'

import './inputDropdownUser.scss'

interface Props {
  user: any
  isSelected?: boolean
  onClick?: (e: any, user: any) => void
}

const InputDropdownUser = ({ user, isSelected, onClick }: Props) => {

  console.log('user', user)

  return (
    <div className={`input-dropdown-user ${isSelected ? 'is-selected' : ''}`}
      onClick={(e) => onClick && onClick(e, user)}
    >
      <UserAvatar user={user} />
      <div className='texts'>
        <div className='user-name'>
          {user.name} {user.surname}
        </div>
        {user.responsible && (
          <div className='user-responsible'>
            Perfil interno de {user.responsible.name} {user.responsible.surname}
          </div>
        )}
      </div>
    </div>
  )
}

export default InputDropdownUser
